import { Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Document, Page, pdf } from "@react-pdf/renderer";
import { useState } from "react";
import { GrDocumentPdf } from "react-icons/gr";
import MyVesselPdfData from "../../../../components/Calculator/MyvesselPdf";
import CommonPdfPreviewModal from "../../../../components/Common/CommonPdfPreviewModal";
import PdfFooter from "../../PortInformation/pdfFooter";
import PdfHeader from "../../PortInformation/pdfHeader";

const DownloadPdf = (props) => {
  const { pdfData, onDownloadPdf = () => { }, isOperationTab = false } = props;
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const downloadFile = ({ filename, url }) => {
    let element = document.createElement("a");
    element.href = url;
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  const pdfdetails = (pdfSaveId) => {
    return <MyVesselPdfData data={pdfData} pdfId={pdfSaveId} />;
  };

  const downloadPDF = async () => {
    const data = await onDownloadPdf();
    if (data?.data?._id) {
      const details = await pdfdetails(data?.data?._id);
      const pdfBlob = await pdf(
        <Document>
          <Page size="A4" orientation="portrait" style={{ paddingBottom: 35 }}>
            <PdfHeader />
            {details}
            <PdfFooter />
          </Page>
        </Document>
      ).toBlob();
      const url = window.URL.createObjectURL(
        new Blob([pdfBlob], { type: "application/pdf" })
      );
      downloadFile({ filename: data?.pdfname, url });
    }
  };

  const documentToPreview = (
    <Document>
      <Page size="A4" orientation="portrait" style={{ paddingBottom: 35 }}>
        <PdfHeader />
        {pdfdetails("")}
        <PdfFooter />
      </Page>
    </Document>
  );

  return (
    <div>
      {isOperationTab ? (
        <Tooltip
          placement="left"
          arrow
          autoFocus={false}
          title={
            <span className="text-sm">
              You can import this PDF into <strong>My Vessel Manual</strong> to create a vessel.
            </span>
          }
        >
          <Button
            onClick={handleOpen}
            variant="outlined"
            className="px-2 py-1 text-sm whitespace-nowrap rounded-none border border-gray-300 text-white bg-[#313C4C]"
            autoFocus={false}
          >
            <div className="flex items-center gap-2 text-transform-initial-pdf text-white">
              <GrDocumentPdf />
              Export vessel
            </div>
          </Button>
        </Tooltip>
      ) : (
        <Button
          onClick={handleOpen}
          variant="outlined"
          className="!h-[24px] !py-0 !px-2.5 text-center text-slate-700 border border-slate-300 !rounded-none text-xs flex items-center gap-1.5 hover:bg-slate-50 transition-colors"
          autoFocus
        >
          <div className="flex items-center gap-1.5 text-transform-initial-pdf text-xs font-medium">
            <GrDocumentPdf className="text-xs" />
            Download PDF
          </div>
        </Button>
      )}

      <CommonPdfPreviewModal
        open={open}
        onClose={handleClose}
        title="Vessel PDF Preview"
        subtitle="A4 Portrait Report • Smart Sea Freight"
        document={documentToPreview}
        onDownload={downloadPDF}
        downloadButtonText={isOperationTab ? "Export vessel" : "Download PDF"}
      />
    </div>
  );
};

export default DownloadPdf;
